import { Dispatch, SetStateAction, useState } from 'react';
import Button from '../../../../../components/Button';
import RadioButton from '../../../../../components/RadioButton';
import styles from './style.module.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from '../../../../../store/store';
import { getCodingExamQuestionThunk } from '../../../../../store/exam/thunks';
import { selectUserId } from '../../../../../store/auth/selectors';
import { selectFetchingCodingExam } from '../../../../../store/exam/selectors';
import { setExamRulesModal } from '../../../../../store/exam/slice';
import { ArrowRightIcon, WarningIcon } from '../../../../../assets/icons/common';
import { CodingExamEntranceIllustration } from '../../../../../assets/illustrations';

const selectLanguageText = 'To take the coding exam, select a programming language';
const startExamText = 'Press the start button when you’re ready';

interface Props {
    cameraAccess: boolean;
    isCameraActive: boolean;
    screenHasRecordError: boolean;
    isScreenRecordActive: boolean;
    startScreenRecord: () => Promise<void>;
    setCameraAccess: Dispatch<SetStateAction<boolean>>;
    startExam: () => void;
    selectedLang: string;
    isFetching: boolean;
    setSelectedLang: Dispatch<SetStateAction<string>>;
    action?: string;
};

export default function PreExam(props: Props) {
    const {
        screenHasRecordError,
        isScreenRecordActive,
        isCameraActive,
        cameraAccess,
        setCameraAccess,
        startScreenRecord,
        startExam,
        selectedLang,
        setSelectedLang,
        isFetching,
        action,
    } = props;

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const userId = useSelector(selectUserId);

    // const fetchExam = () => {
    //     // dispatch(setCodingExamStep('Exam'))
    //     // console.log(location?.state);

    //     if (!location?.state?.jobId || !location?.state?.langs) return;
    //     const language = location?.state?.langs?.length > 1 ? selectedLang : location?.state?.langs[0];

    //     dispatch(getCodingExamQuestionThunk({ 
    //         action: location?.state?.action,
    //         // userId,
    //         language,
    //         question: 0,
    //         jobId: location.state.jobId,
    //     }));
    // };

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <CodingExamEntranceIllustration />

                <span className={styles.title}>
                    {location?.state?.langs?.length > 1 ? selectLanguageText : startExamText}
                </span>

                {location?.state?.langs?.length > 1 && (<div className={styles.languages}>
                    {location?.state?.langs?.map((i: string) => <RadioButton
                        text={i}
                        checked={selectedLang === i}
                        setChecked={() => setSelectedLang(i)}
                    />)}
                </div>)}

                <p className={styles.description}>
                    The exam contains <b>3</b> coding questions
                    {location?.state?.langs?.length === 1 && ` in ${location?.state?.langs[0]}`},<br />
                    each coding question has a limited time.
                </p>

                {!isCameraActive &&
                    <div className={styles.content_warning}>
                        <WarningIcon />
                        <span>Before the exam begins, you must give permission to camera and microphone record the session.</span>
                    </div>}
                {!cameraAccess && <span className={styles.content_link} onClick={() => setCameraAccess(true)}>Enable camera record</span>}

                {!isScreenRecordActive &&
                    <div className={styles.content_warning}>
                        <WarningIcon />
                        <span>Before the exam begins, you must give permission to screen record the session.</span>
                    </div>}
                {screenHasRecordError && <span className={styles.content_link} onClick={startScreenRecord}>Enable screen record</span>}

                <Button
                    type='Primary'
                    loading={isFetching}
                    onClick={startExam}
                    className={styles.CTA}
                    text={action === 'resume' ? 'Resume the exam' : 'Start the exam'}
                    disabled={
                        !isCameraActive ||
                        !isScreenRecordActive ||
                        (location?.state?.langs?.length > 1 && !selectedLang)
                    }
                />

                <div className={styles.extra}>
                    <span className={styles.extra_text}>Please review exam rules before starting the exam</span>
                    <div
                        className={styles.extra_btn}
                        onClick={() => dispatch(setExamRulesModal(true))}
                    >
                        <span>Exams rules</span>
                        <ArrowRightIcon />
                    </div>
                </div>
            </div>
        </div>
    )
};
